import { render, staticRenderFns } from "./BayesCase.vue?vue&type=template&id=6da2e198&scoped=true&"
import script from "./BayesCase.vue?vue&type=script&lang=js&"
export * from "./BayesCase.vue?vue&type=script&lang=js&"
import style0 from "./BayesCase.vue?vue&type=style&index=0&id=6da2e198&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da2e198",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\web\\V-LAB\\project\\bayes-vue2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6da2e198')) {
      api.createRecord('6da2e198', component.options)
    } else {
      api.reload('6da2e198', component.options)
    }
    module.hot.accept("./BayesCase.vue?vue&type=template&id=6da2e198&scoped=true&", function () {
      api.rerender('6da2e198', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BayesCase.vue"
export default component.exports